import { render } from "./COIActionBarRefundSilent.vue?vue&type=template&id=61dd691c"
import script from "./COIActionBarRefundSilent.vue?vue&type=script&lang=js"
export * from "./COIActionBarRefundSilent.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__